import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useEffect, useCallback } from 'react';
import { gsap } from 'gsap';
import { styled } from 'styled-components';
import useAlertStore from '../../store/alerts.js';
import { CloseIcon } from '@fabric-app/icons/icons';
import { shallow as shallow$1 } from '../../../node_modules/zustand/esm/shallow.js';

const Warning = styled.div.withConfig({
  displayName: "WarningDisplay__Warning",
  componentId: "sc-6b0973ce-0"
})([
  `display:inline-flex;padding-left:0px;align-items:center;gap:10px;border-radius:7px;border:1px solid rgba(37,28,63,0.15);opacity:0.7;background:rgba(0,0,0,0.7);color:#fff;font-family:Inter;font-size:13px;font-style:normal;font-weight:500;line-height:20px;letter-spacing:-0.26px;padding-left:8px;`
]);
const CloseButton = styled.button.withConfig({
  displayName: "WarningDisplay__CloseButton",
  componentId: "sc-6b0973ce-1"
})([
  `padding:10px;`
]);
const WarningDisplay = ({ alert: warning }) => {
  const removeAlert = useAlertStore((state) => state.removeAlert, shallow$1);
  const elementId = `warning-${warning.id}`;
  const [showing, setShowing] = React__default.useState(false);
  useEffect(() => {
    gsap.fromTo(`#${elementId}`, {
      opacity: 0,
      y: -10
    }, {
      duration: 0.5,
      opacity: 1,
      y: 0,
      onComplete: () => {
        setShowing(true);
      }
    });
  }, [
    elementId
  ]);
  const hideAlert = useCallback(() => {
    gsap.to(`#${elementId}`, {
      duration: 0.5,
      opacity: 0,
      onComplete: () => {
        setShowing(false);
        removeAlert(warning.id);
      }
    });
  }, [
    warning.id,
    removeAlert,
    elementId
  ]);
  useEffect(() => {
    if (!showing || warning.disableTimeout) return;
    const timeout = setTimeout(hideAlert, warning.timeout);
    return () => {
      clearTimeout(timeout);
    };
  }, [
    warning.timeout,
    hideAlert,
    showing,
    warning.disableTimeout
  ]);
  return /* @__PURE__ */ jsxs(Warning, {
    id: elementId,
    style: {
      opacity: showing ? 1 : 0
    },
    children: [
      warning.content,
      /* @__PURE__ */ jsx(CloseButton, {
        onClick: hideAlert,
        children: /* @__PURE__ */ jsx(CloseIcon, {
          size: 13
        })
      })
    ]
  });
};

export { WarningDisplay as default };
//# sourceMappingURL=WarningDisplay.js.map
